import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Motion";
import { COUNTIES, IMAGES } from "@/data";

export default function Areas() {
  return (
    <div className="bg-cream pt-24">
      <section className="px-6 md:px-12 py-16 relative overflow-hidden">
        <img src={IMAGES.skyline2} alt="" className="absolute inset-0 w-full h-full object-cover opacity-10" />
        <div className="relative max-w-7xl mx-auto">
          <Reveal><p className="font-mono text-xs uppercase tracking-[0.3em] text-green mb-4">Explore Areas</p></Reveal>
          <Reveal delay={0.1}><h1 className="font-serif text-5xl md:text-6xl text-navy tracking-tighter mb-4">Metro Atlanta, county by county.</h1></Reveal>
          <Reveal delay={0.2}><p className="text-lg text-charcoal/75 max-w-xl">Objective overviews of the four counties Richard serves — housing types, featured cities, and new-construction opportunities.</p></Reveal>
        </div>
      </section>
      <section className="px-6 md:px-12 pb-24">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-8">
          {COUNTIES.map((c, i) => (
            <Reveal key={c.slug} delay={i * 0.08}>
              <Link to={`/areas/${c.slug}`} data-testid={`area-card-${c.slug}`} className="group block relative rounded-[2rem] overflow-hidden h-[320px]">
                <img src={c.image} alt={c.name} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-navy/90 to-transparent" />
                <div className="absolute bottom-0 p-8 text-cream">
                  <h2 className="font-serif text-3xl mb-2">{c.name}</h2>
                  <p className="text-sm text-cream/80 max-w-md mb-3">{c.desc}</p>
                  <span className="inline-flex items-center gap-2 text-gold font-semibold text-sm">Explore This County <ArrowUpRight size={16} /></span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
